import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconTextPro = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M12.651 6.231h-4.302v11.537h2.275v-3.791h2.027c2.225 0 3.939-1.714 3.939-3.873s-1.714-3.873-3.939-3.873zM12.651 11.852h-2.027v-3.494h2.027c0.972 0 1.681 0.742 1.681 1.747 0 0.989-0.709 1.747-1.681 1.747z M24.4 17.769h2.456l-2.555-4.351c1.319-0.61 2.225-1.912 2.225-3.362 0-2.11-1.714-3.824-3.84-3.824h-4.615v11.537h2.274v-4.005h1.731l2.324 4.005zM20.346 8.357h2.34c0.857 0 1.566 0.742 1.566 1.698s-0.709 1.714-1.566 1.714h-2.34v-3.412z M33.651 17.999c3.329 0 6-2.637 6-5.999 0-3.379-2.67-5.999-6-5.999s-5.983 2.621-5.983 5.999c0 3.362 2.654 5.999 5.983 5.999zM33.651 15.774c-2.093 0-3.725-1.566-3.725-3.774 0-2.225 1.632-3.791 3.725-3.791s3.725 1.566 3.725 3.791c0 2.209-1.632 3.774-3.725 3.774z" }),
    width: 48,
});

export { IconTextPro };
